import { LMFormatterService } from './lm-formatter.service';

export const lmCheckBoxFormatter = (
  lmFormatterService: LMFormatterService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  datagrid: SohoDataGridStatic
): string => {

  if (lmFormatterService.isTotalRow(dataView) && cell === 0) {
    return '';
  }

  // --------------------------------------------------------------------------
  // Use regular formatter if this row isn't a totalling row.
  // --------------------------------------------------------------------------
  return Soho.Formatters.SelectionCheckbox(row, cell, value, columnDef, dataView, datagrid);
};
